import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  SimpleGrid,
  Image,
  Text,
  ModalFooter,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { ContentStyleImages } from "@/components/design/content_style_images";
import { selectMode } from "@/reducer/modeslice";
import { Style } from "@/types/design";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  changeMode: (mode: Style) => void;
};
const SmrModelModal = (props: Props) => {
  const { isOpen, onClose, changeMode } = props;
  const { design } = useAppSelector(selectMode);
  
  const images = ContentStyleImages.filter(
        (image) => image.category === "室内设计"
      );

  const [currentMode, setCurrentMode] = useState<Style>(design.style);

  useEffect(() => {
    if (isOpen) {
      setCurrentMode(design.style);
    }
  }, [isOpen]);

  const handleChangeMode = (mode: Style) => {
    // setCurrentModeIndex(index);
    setCurrentMode(mode);
    
    
  };

  const handleChangeModel = () => {
    changeMode(currentMode);
    onClose();
  }

  return (
    <>
      <Modal
        size={"5xl"}
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent bg="#0C0B10" h="80vh">
          <ModalHeader color="#FFFFFF" fontSize={"18px"}>
            选择模型
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} />
          <ModalBody pb={6}>
            <Box mt="22px">
              <SimpleGrid columns={5} spacing={"20px"}>
                {images &&
                  images.map((item) => (
                    <Box
                      key={item.name}
                      boxSizing="border-box"
                      cursor="pointer"
                      onClick={() => handleChangeMode(item)}
                    >
                      <Box
                        w="100%"
                        h="160px"
                        borderRadius={"10px"}
                        overflow="hidden"
                        border={
                          item.name === currentMode?.name
                            ? "3px solid #496AE1"
                            : "none"
                        }
                      >
                        <Image
                          w="100%"
                          h="100%"
                          objectFit="cover"
                          src={require(`/src/assets/design/contentstyles/${item.src}`)}
                          
                        />
                      </Box>
                      <Box mt="10px" textAlign={"center"} color={"#FFFFFF"} fontSize="16px">{item.name}</Box>
                    </Box>
                  ))}
              </SimpleGrid>
            </Box>
            
          </ModalBody>
          <ModalFooter>
          <Button
              w="76px"
              h="32px"
              mr="15px"
              bg="#1E253F"
              color={"#FFFFFF"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={"38px"}
              _hover={{
                bg: "#CBD1DF",
                color: "#8E94A9",
              }}
              onClick={() => onClose()}
            >
              取消
            </Button>
            <Button
              w="76px"
              h="32px"
              color={"#FFFFFF"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={"38px"}
              background={"linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"}
              _hover={{
                background: "linear-gradient(90deg, #496AE1 0%, #66E8E0 100%)",
              }}
              onClick={handleChangeModel}
            >
              确定
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SmrModelModal;
